import React from 'react';
import Container from "react-bootstrap/Container";

/**
 * Footer component displaying various meta information such as versions and copy rights.
 */
class Footer extends React.Component {

  render() {
    // Note there is an __about endpoint returning build date, version and doc link
    return (
      <Container className="Footer text-muted">
        <a href={process.env.REACT_APP_PLATFORM_SITE} target="_blank" rel="noopener noreferrer">
          Ontotext Platform Workbench
        </a>
        {' '}
        {process.env.REACT_APP_VERSION} © 2002–2021
        {' '}
        <a href={process.env.REACT_APP_ONTOTEXT_SITE} target="_blank" rel="noopener noreferrer">
          Ontotext.
        </a>
        {' '}
        All rights reserved.
      </Container>
    );
  }

}

export default Footer;
